var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreValueIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.655 7.281L29.71 4.017a3.579 3.579 0 014.37 2.735l.112.53h1.47a3.65 3.65 0 013.65 3.649v9.454h.715a2.196 2.196 0 012.197 2.197v5.797a2.196 2.196 0 01-2.197 2.197h-.715v5.32a3.415 3.415 0 01-3.416 3.416H4.873a3.415 3.415 0 01-3.416-3.416V10.921a3.649 3.649 0 013.65-3.64h11.548zm21.2 13.104V16.52a1.963 1.963 0 00-1.959-1.96h-30.8c-.845 0-1.59-.234-2.183-.65v21.985a1.963 1.963 0 001.96 1.96h31.023a1.963 1.963 0 001.96-1.96v-5.32h-5.327a3.41 3.41 0 01-3.41-3.409v-3.373a3.41 3.41 0 013.41-3.41h5.327zm2.913 2.197v5.797a.741.741 0 01-.742.741H32.53a1.953 1.953 0 01-1.953-1.953v-3.373c0-1.079.874-1.953 1.953-1.953h7.497a.74.74 0 01.741.74zm-6.552 1.443a1.457 1.457 0 100 2.913 1.457 1.457 0 000-2.913zM10.83 8.737H5.106a2.193 2.193 0 00-2.193 2.186v.058c.028 1.252.92 2.124 2.184 2.124h30.799c.706 0 1.389.218 1.96.618V10.93a2.194 2.194 0 00-2.194-2.193H34.5l.428 2.034a.73.73 0 01-.712.878H5.096a.729.729 0 01-.176-1.434l5.911-1.478zm6.077-.018a.364.364 0 00.026-.007l13.13-3.283a2.123 2.123 0 012.593 1.623l.662 3.141H11.01l5.898-1.474z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreValueIcon04);
export default __webpack_public_path__ + "static/media/core-value-icon04.7359af29a714549e011557fa76163944.svg";
export { ForwardRef as ReactComponent };